import { Directive, Inject, Injector, OnInit } from "@angular/core";
import { UserSettings, UserSettingsToken } from "@farris/devkit";
import { NumberSpinnerComponent } from '@farris/ui-number-spinner';
@Directive({
  selector: '[farris-number-localization]'
})
export class FarrisNumberLocalizationDirective implements OnInit {
  constructor(private injector: Injector, @Inject(UserSettingsToken) private userSettings: UserSettings, private componentRef: NumberSpinnerComponent) {

  }
  ngOnInit(): void {
    this.localize();
  }
  private localize() {
    return;
    // æ¶åéé¢ç­é®é¢ï¼æ°å­æ ¼å¼åä¸äºå¤ç
    if (this.userSettings && this.userSettings.numberFormat && this.componentRef) {
      const { negativeSign = null, numberDecimalDigits = null, numberDecimalSeparator = null, numberGroupSeparator = null } = this.userSettings.numberFormat || {};
      // è´å·
      if (negativeSign) {
        // this.componentRef.prefix = negativeSign;
      }
      // å°æ°ä½æ°
      if (numberDecimalDigits !== null) {
        this.componentRef.precision = numberDecimalDigits;
        this.componentRef.formatOptions['precision'] = numberDecimalDigits;
      }
      // å°æ°ç¹ç¬¦å·
      if (numberDecimalSeparator !== null) {
        this.componentRef.decimalSeparator = numberDecimalSeparator;
        this.componentRef.formatOptions['decimalSeparator'] = numberDecimalSeparator;
      }
      // ååä½ç¬¦å·
      if (numberGroupSeparator !== null) {
        this.componentRef.groupSeparator = numberGroupSeparator;
        this.componentRef.formatOptions['groupSeparator'] = numberGroupSeparator;
      }
      this.componentRef.updateValue(this.componentRef.value);
    }
  }
}